import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}

export default function Obrigado() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    // Dispara PageView e Lead SOMENTE na página /obrigado, apenas uma vez no carregamento
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
      window.fbq('track', 'Lead');
    }
  }, []);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(
      'Acabei de me inscrever na Seletiva Four Models em Campo Novo do Parecis - MT! 🌟\n\n📅 Data: 15/03/2026 • Domingo\n⏰ Horário: 15h\n📍 Local: ACIC CDL - Campo Novo do Parecis - MT\n\nInscrição gratuita para modelos, atores e influencers de 03 a 35 anos! Corre lá e se inscreve também! 👇\nhttps://campononovo.fourmodelsseletivas.com.br'
    );
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-black border-b border-yellow-500/20 py-3 px-4">
        <div className="max-w-7xl mx-auto flex items-center justify-center">
          <img
            alt="Four Models"
            className="h-9 sm:h-10 object-contain"
            src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/3c6853a00769ef0b898cf7c7be2b9fe6.png"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-10 sm:py-16">
        <div className="max-w-2xl w-full text-center">

          {/* Ícone de sucesso animado */}
          <div className="relative inline-flex items-center justify-center mb-6 sm:mb-8">
            <div className="absolute w-28 h-28 sm:w-32 sm:h-32 bg-yellow-500/10 rounded-full animate-ping"></div>
            <div className="absolute w-20 h-20 sm:w-24 sm:h-24 bg-yellow-500/20 rounded-full animate-pulse"></div>
            <div className="relative w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center shadow-2xl shadow-yellow-500/40">
              <i className="ri-check-line text-black text-3xl sm:text-4xl font-black"></i>
            </div>
          </div>

          {/* Título */}
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-white mb-3 sm:mb-4 leading-tight">
            Inscrição{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              Confirmada!
            </span>
          </h1>

          <p className="text-gray-300 text-base sm:text-xl mb-8 sm:mb-10 max-w-lg mx-auto leading-relaxed">
            Parabéns! Sua vaga está garantida. Entraremos em contato pelo{' '}
            <strong className="text-white">WhatsApp</strong> com todos os detalhes.
          </p>

          {/* Card de informações do evento */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-2xl p-5 sm:p-9 mb-5 sm:mb-8 text-left shadow-2xl">
            <p className="text-yellow-500 text-xs font-bold tracking-widest uppercase mb-4 sm:mb-5 flex items-center gap-2">
              <i className="ri-calendar-check-fill text-base"></i>
              Detalhes do Evento
            </p>

            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-yellow-500/10 border border-yellow-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-event-fill text-yellow-500 text-base sm:text-lg"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider">Data</p>
                  <p className="text-white font-bold text-sm sm:text-base">15 de Março de 2026 • Domingo</p>
                </div>
              </div>

              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-yellow-500/10 border border-yellow-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-yellow-500 text-base sm:text-lg"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider">Horário</p>
                  <p className="text-white font-bold text-sm sm:text-base">15h (não se atrase!)</p>
                </div>
              </div>

              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-yellow-500/10 border border-yellow-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-2-fill text-yellow-500 text-base sm:text-lg"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider">Local</p>
                  <p className="text-white font-bold text-sm sm:text-base">ACIC CDL</p>
                  <p className="text-yellow-500 text-xs sm:text-sm font-semibold">Campo Novo do Parecis – MT</p>
                </div>
              </div>
            </div>
          </div>

          {/* Próximos passos */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-5 sm:p-9 mb-5 sm:mb-8 text-left">
            <p className="text-white text-xs sm:text-sm font-bold tracking-widest uppercase mb-4 sm:mb-5 flex items-center gap-2">
              <i className="ri-list-check-3 text-yellow-500 text-base"></i>
              Próximos Passos
            </p>

            <div className="space-y-3 sm:space-y-4">
              {[
                { step: '1', text: <>Aguarde nosso contato pelo <strong className="text-white">WhatsApp</strong> com a confirmação e orientações.</> },
                { step: '2', text: <>Compareça no dia <strong className="text-white">15/03/2026 às 15h</strong> no local indicado.</> },
                { step: '3', text: <>Menores de 18 anos devem estar acompanhados de um <strong className="text-white">responsável legal</strong>.</> },
              ].map((item) => (
                <div key={item.step} className="flex items-start gap-3 sm:gap-4">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-black font-black text-xs">{item.step}</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Dica de antecedência */}
          <div className="bg-gradient-to-r from-yellow-500/10 to-yellow-600/5 border border-yellow-500/40 rounded-2xl p-4 sm:p-6 mb-5 sm:mb-8 flex items-start gap-3 sm:gap-4 text-left">
            <div className="w-9 h-9 sm:w-10 sm:h-10 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-time-fill text-black text-lg sm:text-xl"></i>
            </div>
            <div>
              <p className="text-yellow-400 font-black text-xs sm:text-sm uppercase tracking-wider mb-1">Chegue com antecedência!</p>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                Recomendamos chegar pelo menos <strong className="text-white">30 minutos antes</strong> do horário marcado. Isso garante que você faça o credenciamento com calma e aproveite a palestra completa antes da avaliação.
              </p>
            </div>
          </div>

          {/* FAQ Seleção */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-5 sm:p-9 mb-6 sm:mb-8 text-left">
            <p className="text-white text-xs sm:text-sm font-bold tracking-widest uppercase mb-5 sm:mb-6 flex items-center gap-2">
              <i className="ri-question-answer-fill text-yellow-500 text-base"></i>
              Tudo que você precisa saber
            </p>

            <div className="space-y-5 sm:space-y-6">

              {/* O que é */}
              <div className="border-b border-white/5 pb-5">
                <div className="flex items-center gap-3 mb-2 sm:mb-3">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-yellow-500/10 border border-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-eye-line text-yellow-500 text-xs sm:text-sm"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm">O que é a Seleção de Modelos e Atores?</h3>
                </div>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed pl-10">
                  É uma <strong className="text-white">entrevista avaliativa</strong> do perfil e talento dos candidatos. Não há desfile, não é necessário decorar texto e nem apresentar book fotográfico. Simples assim!
                </p>
              </div>

              {/* O que acontece */}
              <div className="border-b border-white/5 pb-5">
                <div className="flex items-center gap-3 mb-2 sm:mb-3">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-yellow-500/10 border border-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-slideshow-3-line text-yellow-500 text-xs sm:text-sm"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm">O que acontece na Seleção?</h3>
                </div>
                <div className="text-gray-400 text-xs sm:text-sm leading-relaxed pl-10 space-y-2">
                  <p>Antes da avaliação, você e seu responsável participam de uma <strong className="text-white">palestra com a diretora da agência</strong>, onde serão explicados a metodologia, etapas, desafios da carreira, casos de sucesso e o investimento necessário.</p>
                  <p>Após a palestra, os candidatos são encaminhados para a avaliação. <strong className="text-white">O resultado é divulgado na hora.</strong></p>
                </div>
              </div>

              {/* Como se preparar */}
              <div className="border-b border-white/5 pb-5">
                <div className="flex items-center gap-3 mb-2 sm:mb-3">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-yellow-500/10 border border-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-flash-line text-yellow-500 text-xs sm:text-sm"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm">Como se preparar?</h3>
                </div>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed pl-10">
                  Vá o mais <strong className="text-white">natural possível</strong> e demonstre suas características reais. Mantenha a calma, seja confiante e saiba o motivo de estar na seleção. Não é preciso nenhuma preparação especial!
                </p>
              </div>

              {/* Menor de idade */}
              <div className="border-b border-white/5 pb-5">
                <div className="flex items-center gap-3 mb-2 sm:mb-3">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-yellow-500/10 border border-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-parent-line text-yellow-500 text-xs sm:text-sm"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm">Menor de idade precisa ir acompanhado?</h3>
                </div>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed pl-10">
                  <strong className="text-yellow-400">Sim.</strong> Candidatos menores de idade precisam estar acompanhados de um maior de idade responsável. Caso os pais não possam comparecer, outro responsável pode acompanhar, desde que haja o consentimento dos pais.
                </p>
              </div>

              {/* Como se vestir */}
              <div>
                <div className="flex items-center gap-3 mb-2 sm:mb-3">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-yellow-500/10 border border-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-t-shirt-line text-yellow-500 text-xs sm:text-sm"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm">Como devo ir à Seleção?</h3>
                </div>
                <div className="pl-10 space-y-2">
                  <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                    Use <strong className="text-white">roupas confortáveis e básicas</strong>. As meninas podem estar com o cabelo preso ou solto e natural, com pouca ou nenhuma maquiagem.
                  </p>
                  <div className="bg-yellow-500/5 border border-yellow-500/20 rounded-xl p-3 sm:p-4 mt-2">
                    <p className="text-yellow-400 text-xs font-bold uppercase tracking-wider mb-1.5 flex items-center gap-1.5">
                      <i className="ri-alert-line text-sm"></i>
                      Atenção
                    </p>
                    <p className="text-gray-400 text-xs leading-relaxed">
                      O uso de acessórios em excesso, maquiagem pesada ou qualquer forma de cobrir suas características reais pode <strong className="text-white">interferir negativamente</strong> na avaliação. Seja você mesmo(a)!
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Botão WhatsApp */}
          <button
            type="button"
            onClick={handleWhatsAppShare}
            className="w-full bg-green-500 hover:bg-green-600 text-white px-6 py-4 rounded-full text-sm sm:text-base font-bold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-3 mb-3 sm:mb-4"
          >
            <i className="ri-whatsapp-fill text-xl sm:text-2xl"></i>
            Compartilhar com Amigos no WhatsApp
          </button>

          <button
            type="button"
            onClick={() => navigate('/')}
            className="w-full bg-transparent border border-yellow-500/40 hover:border-yellow-500 text-yellow-500 hover:text-yellow-400 px-6 py-4 rounded-full text-sm sm:text-base font-bold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Voltar para o site
          </button>

          <p className="text-gray-600 text-xs mt-5">
            Dúvidas? Entre em contato pelo WhatsApp ou redes sociais da Four Models.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-5 px-4 text-center">
        <p className="text-gray-600 text-xs">
          © 2026 Four Models. Todos os direitos reservados.
        </p>
      </footer>
    </div>
  );
}
